import { useState, useEffect } from "react";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
} from "@heroicons/react/24/outline";
import TabList from "./../../../common/TabList";
import MinorAliments from "./minorAliments";
import { Tab } from "@headlessui/react";
import { Fragment } from "react";
import MedicationReview from "./medicationReview";
import Notes from "./notes";
import ChartNav from "./../../../common/ChartNav";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const medicalSummaryTabs = [
  { name: "Notepad Notes", disabled: false },
  { name: "Minor Ailments", disabled: false },
  { name: "Medication Review", disabled: false },
];

const MedicalSummary = ({ open = false, patient }) => {
  const [showMedicalSummary, setShowMedicalSummary] = useState(open);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showMenu, setShowMenu] = useState(true);
  const { summaryId, type, id: patientId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { medicalSummaryRecord } = useSelector((state) => state.medicalSummary);

  // Determine which tab should be active based on the URL type parameter
  useEffect(() => {
    if (!type) {
      // If no type parameter, redirect to default (Notes)
      navigate(`/patient/${patientId}/medical-summary/NOTES`, { replace: true });
      return;
    }

    // Use the type parameter from URL to determine the correct tab
    if (type === 'MA') {
      setSelectedIndex(1); // Minor Ailments tab (index 1)
    } else if (type === 'AMR') {
      setSelectedIndex(2); // Medication Review tab (index 2)
    } else if (type === 'NOTES' || type === 'Notes' || type === 'notes' || type === 'N') {
      setSelectedIndex(0); // Notes tab (index 0)
    } else {
      // Default to Notes for any unrecognized type
      setSelectedIndex(0);
      navigate(`/patient/${patientId}/medical-summary/NOTES`, { replace: true });
    }
  }, [type, navigate, patientId]);

  // Save the selected tab when it changes and navigate to the appropriate URL
  const handleTabChange = (index) => {
    setSelectedIndex(index);
    
    // Navigate to the appropriate URL based on the selected tab
    if (index === 1) {
      // Minor Ailments tab
      navigate(`/patient/${patientId}/medical-summary/MA`);
    } else if (index === 2) {
      // Medication Review tab
      navigate(`/patient/${patientId}/medical-summary/AMR`);
    } else if (index === 0) {
      // Notes tab
      navigate(`/patient/${patientId}/medical-summary/NOTES`);
    }
  };

  return (
    <>
      <Tab.Group>
        <Tab.Panels as={Fragment}>
          <Tab.Panel as={Fragment}>
            <Tab.Group selectedIndex={selectedIndex} onChange={handleTabChange}>
              <div className="flex flex-1 overflow-hidden gap-9">

                <div
                  className={`flex gap-5  relative ${showMenu ? "min-w-[320px] 2xl:min-w-[400px]" : ""
                    }`}
                >
                  <ChartNav />
                  <div
                    className={`flex flex-col transition pt-2 ${!showMenu ? "-translate-x-full absolute" : "flex-1"
                      }`}
                  >
                    <div className="flex w-80 pt-1 pb-2 align-top gap-2">
                      <h5 className="text-xl font-bold text-teal-300">Medical Summary</h5>
                    </div>
                    <TabList listItems={medicalSummaryTabs} />
                  </div>
                  <div className={`relative w-[7px] transition bg-gray-100 group`}>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowMenu(!showMenu);
                      }}
                      className={`absolute flex items-center justify-center w-6 h-6 m-auto bg-teal-300 top-64 -right-2 rounded-3xl opacity-100 cursor-pointer`}
                    >
                      {showMenu ? (
                        <ChevronLeftIcon className="w-5 h-5 text-white -ml-0.5" />
                      ) : (
                        <ChevronRightIcon className="w-5 h-5 text-white ml-0.5" />
                      )}
                    </button>
                  </div>
                </div>


                <div
                  className={`flex flex-1 pt-12 ${showMenu
                    ? "max-w-[calc(100%-335px)] 2xl:max-w-[calc(100%-436px)]"
                    : "border-r-4 border-gray-20"
                    }`}
                >
                  <Tab.Panels as={Fragment}>
                  <Tab.Panel as={Fragment}>
                      <div className="flex flex-col w-full gap-4 -mt-12 text-teal-300">
                        <Notes patient={patient} currentTabIndex={selectedIndex} />
                      </div>
                    </Tab.Panel>
                    <Tab.Panel as={Fragment}>
                      <div className="flex flex-col w-full gap-4 -mt-12 text-teal-300">
                        <MinorAliments patient={patient} currentTabIndex={selectedIndex} />
                      </div>
                    </Tab.Panel>
                    <Tab.Panel as={Fragment}>
                      <div className="flex flex-col w-full gap-4 -mt-12 text-teal-300">
                        <MedicationReview patient={patient} currentTabIndex={selectedIndex} />
                      </div>
                    </Tab.Panel>                   
                  </Tab.Panels>
                </div>
              </div>
            </Tab.Group>
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
     
    </>)
};

export default MedicalSummary;
